

/**
 * Dynamic diagonal slash handler for disabled product option buttons
 */
function updateDisabledButtonSlashes() {
  // Check if the selectors exist in the DOM
  const disabledInputs = document.querySelectorAll(
    '.product-form__input--pill .option__container input[type=radio]:disabled, ' +
    '.product-form__input--pill .option__container input[type=radio].disabled'
  );
  
  // Do nothing if selectors are not found
  if (disabledInputs.length === 0) return;
  
  disabledInputs.forEach(input => {
    const label = input.nextElementSibling;
    if (!label || label.tagName !== 'LABEL') return;
    
    // Get label dimensions
    const width = label.offsetWidth;
    const height = label.offsetHeight;
    
    // Skip if dimensions are invalid
    if (width === 0 || height === 0) return;
    
    // Calculate angle for perfect corner-to-corner diagonal
    const angleInRadians = Math.atan(height / width);
    const angleInDegrees = angleInRadians * (180 / Math.PI);
    
    // Apply the calculated rotation
    label.style.setProperty('--slash-angle', `${angleInDegrees}deg`);
  });
}

// Run when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateDisabledButtonSlashes);
} else {
  updateDisabledButtonSlashes();
}

// Watch for changes to .option__container and re-run when it's reloaded
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    // Check if any nodes were added
    if (mutation.addedNodes.length > 0) {
      mutation.addedNodes.forEach((node) => {
        // Check if the added node is or contains .option__container
        if (node.nodeType === 1) { // Element node
          if (node.matches && node.matches('.option__container')) {
            updateDisabledButtonSlashes();
          } else if (node.querySelector && node.querySelector('.option__container')) {
            updateDisabledButtonSlashes();
          }
        }
      });
    }
  });
});

// Start observing when DOM is ready
function startObserving() {
  // Observe the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startObserving);
} else {
  startObserving();
}